import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { useEffect } from "react";
import Button from "../shared/Button";
import { handleActiveSelect } from "../../features/layout/layoutSlice";
import { useScrollLock } from "../../hooks/useScrollLock";
import { closeAllModal, showModal } from "../../features/modal/modalSlice";
import { resetAddLoadState, setAracData, setPaketlemeData, setPaymentData, setRoute, setYukData } from "../../features/addLoad/addLoadSlice";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;

  .modal {
    width: 50%;
    height: 200px;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    padding: 30px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    justify-content: space-between;


    .content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
        p{
            font-size: 25px;
            font-weight: 600;
            color:var(--color-dark);
            line-height: 21px;
        }
        .btn{
            margin-top: 20px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;
        }
    }
  }
`;

const ContinueModal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { memorieRouteData } = useSelector((state) => state.addLoad);
  
  const { modalLocation } = useSelector((state) => state.modal);
  const { lockScroll, unlockScroll } = useScrollLock();

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  const handleUpdate = () => {
    dispatch(setRoute(memorieRouteData?.routeData))
    dispatch(setAracData(memorieRouteData?.aracData))
    dispatch(setPaketlemeData(memorieRouteData?.paketlemeData))
    dispatch(setPaymentData(memorieRouteData?.paymentData))
    dispatch(setYukData(memorieRouteData?.yukData))

    dispatch(closeAllModal(null))
  }

  const handleDelete = () => {
    dispatch(closeAllModal(null))
    dispatch(resetAddLoadState())
  }


  return (
    <Container onClick={() => dispatch(showModal(null))}>
      <div
        className="modal"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(handleActiveSelect(null));
        }}
      >
        <div className="content">
            <p>Yaptığınız Değişiklikler İle Devam Etmek İster Misiniz?</p>
            <div className="btn">
                <Button handleClick={handleUpdate} color={"#F4F4F4"} background={"#E85446"} width="100%" radius={"10px"} text={"Devam Et"} fontSize="14px"/>
                <Button handleClick={handleDelete} color={"#F4F4F4"} background={"#E85446"} width="100%" radius={"10px"} text={"İptal Et"} fontSize="14px"/>
            </div>
        </div>
      </div>
    </Container>
  );
};

export default ContinueModal;
